import {
  DomainProbeResult,
  DomainProbeStatus,
} from '@tribeplatform/gql-client/types'

import { StatusActive } from './StatusActive.js'
import { StatusError } from './StatusError.js'
import { StatusPending } from './StatusPending.js'
import { StatusReady } from './StatusReady.js'
import { StatusTaken } from './StatusTaken.js'

interface Props {
  domainProbeResult: DomainProbeResult
}

export const DomainTransferStatus = ({ domainProbeResult }: Props) => {
  const { status, dnsRecords, parseResult, customHostnameStatus } =
    domainProbeResult
  const {
    isApex,
    parts: { domain },
  } = parseResult

  switch (status) {
    case DomainProbeStatus.Active:
      return <StatusActive domain={domain} />

    case DomainProbeStatus.Available:
    case DomainProbeStatus.Pending:
      return (
        <StatusPending
          domain={domain}
          isApex={isApex}
          customHostnameStatus={customHostnameStatus}
          dnsRecords={dnsRecords}
        />
      )

    case DomainProbeStatus.ReadyForTransfer:
      return <StatusReady domain={domain} dnsRecords={dnsRecords} />

    case DomainProbeStatus.Taken:
      return <StatusTaken domain={domain} dnsRecords={dnsRecords} />

    case DomainProbeStatus.Invalid:
    case DomainProbeStatus.RestrictedFeature:
    case DomainProbeStatus.Reserved:
      return <StatusError domain={domain} status={status} />
    default: {
      const _exhaustiveCheck: never = status
      return <StatusError domain={domain} status={status} />
    }
  }
}
